import { useParams, useLocation, useNavigate } from 'react-router-dom';
import { SUPPORTED_LANGS, LANG_STORAGE_KEY } from '../../i18n/index.js';

const LANG_LABELS = { en: 'EN', de: 'DE' };

/**
 * LanguageSwitcher
 * Self-contained EN/DE pill toggle. Reads the current language from the
 * "/:lang/..." URL segment and swaps it in place when clicked, preserving
 * whatever page you're on (e.g. /en/terms -> /de/terms). Saves the choice
 * so it's remembered on the next visit — see src/i18n/LangRouting.jsx.
 */
const LanguageSwitcher = ({ className = '' }) => {
  const { lang } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  const switchTo = (code) => {
    if (code === lang) return;
    const segments = location.pathname.split('/');
    segments[1] = code; // segments[0] is '' (leading slash), segments[1] is the lang code
    window.localStorage.setItem(LANG_STORAGE_KEY, code);
    navigate(segments.join('/') || `/${code}`);
  };

  return (
    <div className={`flex items-center rounded-full bg-nav-surface p-0.5 ${className}`}>
      {SUPPORTED_LANGS.map((code) => (
        <button
          key={code}
          onClick={() => switchTo(code)}
          aria-label={`Switch to ${LANG_LABELS[code]}`}
          aria-pressed={lang === code}
          className={`px-2.5 py-1 text-xs font-semibold rounded-full transition-colors ${
            lang === code
              ? 'bg-vizcorn-blue text-white'
              : 'text-nav-text hover:text-white'
          }`}
        >
          {LANG_LABELS[code]}
        </button>
      ))}
    </div>
  );
};

export default LanguageSwitcher;
